/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {syncDocument} from '../api'

export const useMutationSyncDocument = createReactQueryMutationHook('syncDocument', syncDocument)
